module.exports = __webpack_public_path__ + "static/media/QF.b24421db.png";